import { Schema } from "nutso";

import { Group } from "../models/Group";

export const groupSchema: Schema<Group, any, any> = {
  type: "object",
  properties: {
    id: {
      type: "string",
    },
    groupEmailAddress: {
      type: "string",
    },
    orgId: {
      type: "string",
    },
    name: {
      type: "string",
    },
    memberUids: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
};
